var map = {
	"./hkie.png": "cfa2",
	"./hkie2.png": "6eca",
	"./hkig.png": "c3a1",
	"./hkig2.png": "afbe",
	"./hkis.png": "0550",
	"./hkis2.png": "3f5c",
	"./hkoig2.png": "9c54"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a11d";